import { combineReducers } from "redux";
import { USER_LOGOUT } from "../actions/login/types";
import login from "./login";
import productos from "./productos";
import servicios from "./servicios";
import proveedores from "./proveedores";
import clientes from "./clientes";
import compras from "./compras";
import ventas from "./ventas";
import cortes from "./cortes";
import gastos from "./gastos";
import promociones from "./promociones";
import reparaciones from "./reparaciones";
import encargos from "./encargos";
import facturacion from "./facturacion";
import usuarios from "./usuarios";

// Modulos de negocio agregan aqui su propio reducer conforme se construyen.
const appReducer = combineReducers({
  login,
  productos,
  servicios,
  proveedores,
  clientes,
  compras,
  ventas,
  cortes,
  gastos,
  promociones,
  reparaciones,
  encargos,
  facturacion,
  usuarios,
});

// Al despachar USER_LOGOUT borramos TODO el estado en memoria del store.
const rootReducer = (state, action) => {
  if (action && action.type === USER_LOGOUT) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
